import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useSearchParams } from "react-router-dom";
import Layout from "@/_LayoutsRelated/layout/Layout";
import OilPaymentSuccess from "./components/OilPaymentSuccess/OilPaymentSuccess";
import OilPaymentFailed from "./components/OilPaymentFailed/OilPaymentFailed";
var OilPaymentStatusPage = function OilPaymentStatusPage() {
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var status = searchParams.get("status");
  var isSuccess = status === "paid";
  return /*#__PURE__*/React.createElement(Layout, {
    hasNavBar: true,
    headHideLinks: true,
    disableLoader: true,
    hideOrangeHeadBtn: true,
    showUserAvatar: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-[#f4f7fb] min-h-screen py-10 px-4 flex items-start justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full max-w-[520px]"
  }, isSuccess ? /*#__PURE__*/React.createElement(OilPaymentSuccess, null) : /*#__PURE__*/React.createElement(OilPaymentFailed, null))));
};
export default OilPaymentStatusPage;